import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Note, Page } from '../../../helbest';
import { API } from '../../../request/api';
import styles from './Address.module.css';
import Dataform from './Dataform/Dataform';

const AddressEdit = ({ Login, history, match }) => {
  const [addr_list, set_addr_list] = useState([]);
  const params = useParams();

  const get = () => {
    API.get
      .userAddresses(Login.city_id)
      .then((response) => {
        if (response.success) {
          set_addr_list(response.data);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const address = addr_list.filter((item) => item.id === Number(params.route));

  const [region_list, set_region_list] = useState([]);
  const [lat, set_lat] = useState('35.6892');
  const [lng, set_lng] = useState('51.389');
  const [addr, set_addr] = useState('');
  const [region, set_region] = useState('');
  const [zip_code, set_zip_code] = useState('');

  useEffect(() => {
    if (addr_list) {
      set_addr(address[0]?.address);
      set_region(address[0]?.region_id);
      set_zip_code(address[0]?.zip_code);
    }
    // eslint-disable-next-line
  }, [addr_list]);

  const get_regions = () => {
    API.get
      .regions(Login.city_id)
      .then((response) => {
        if (response.success) {
          set_region_list(response.data);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const edit_address = (address_id) => {
    API.put
      .userAddresses(region, addr, lat, lng, zip_code, address_id)
      .then((response) => {
        if (response.success) {
          get();
          Note.success('تغییرات انجام شد');
          history.push('/delivery/');
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        Note.error('خطا در اتصال به سرور');
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    // user_location();
    get();
    get_regions();
    // eslint-disable-next-line
  }, []);

  const back_address = '/delivery/';

  return (
    <Page
      address={back_address}
      back={true}
      className={`${styles.PageAddress} page-address`}
      footer={match.params.route === 'd' || match.params.route === 's' ? <div /> : null}
      header_back_title={
        match.params.route === 'd' || match.params.route === 's' ? `بازگشت به سبد` : ''
      }
      headerFix
      logo
      mobileContainer
      no_header_center_label={match.params.route === 'd' || match.params.route === 's'}
      showFooter
      title="آدرس ها">
      <div style={{ margin: '0 10px 100px 10px' }}>
        <label
          className="radio-input no-mr radio-ml adresses-container"
          style={{
            paddingRight: '8px',
            paddingLeft: '8px',
            paddingBottom: '8px',
            marginLeft: 0,
            marginRight: 0
          }}>
          <Dataform
            addr={addr}
            edit_address={edit_address}
            isInEditPage
            item={address[0]}
            lat={lat}
            lng={lng}
            region={region}
            region_list={region_list}
            set_addr={set_addr}
            set_lat={set_lat}
            set_lng={set_lng}
            set_region={set_region}
            set_zip_code={set_zip_code}
            zip_code={zip_code}
          />
        </label>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(AddressEdit);
